import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-live-campaigns',
    templateUrl: './live-campaigns.component.html',
    styleUrls: ['./live-campaigns.component.scss']
})
export class LiveCampaignsComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
